let webSocketMixin = {
  data() {
    return {
      // websocket相关
      websock: null, // websocket连接实例
      reconnectCount: 0, //重连次数
      registerCount: 0, // 注册次数
      aliveFalseCount: 0, //心跳失败次数
      AliveInterVal: null, // 心跳检测（定时器）
      WebsocketInterVal: null, // websocket自检（定时器）
      keepAlive: true, // 心跳状态
      lockReconnect: true, //重连锁   true 开锁可重连，反之不可
      wsStatus: false // true websock连接正常 ， 反之连接关闭
    };
  },
  methods: {
    //websocket相关函数
    initWebSocket() {
      //建立连接
      this.lockReconnect = false;
      //初始化weosocket
      const wsuri = sessionStorage.websocketIp + "/webSocketServer";
      //建立连接
      this.mainLog("建立WebSocket连接！");
      this.websock = new WebSocket(wsuri);
      //连接成功
      this.websock.onopen = this.websocketonopen;
      //连接错误
      this.websock.onerror = this.websocketonerror;
      //接收信息
      this.websock.onmessage = this.websocketonmessage;
      //连接关闭
      this.websock.onclose = this.websocketclose;
    },
    //websocket检测
    checkSocket() {
      let that = this;
      clearInterval(that.WebsocketInterVal);
      that.WebsocketInterVal = null;
      that.reconnectCount = 0;
      this.WebsocketInterVal = setInterval(() => {
        if (!that.wsStatus) {
          if (that.reconnectCount < 10) {
            that.mainLog(
              "WebsocketStatus为false，重连次数为" +
              that.reconnectCount +
              "，重连锁（true开锁可重连，反之不可）：" +
              that.lockReconnect
            );
            if (that.lockReconnect) {
              if (this.$route.path == "/customer") {
                this.$vux.toast.show({
                  type: "text",
                  width: "16em",
                  time: 5000,
                  text: "网络异常，正在重连..."
                });
              }
              that.initWebSocket();
              that.reconnectCount++;
            }
          } else {
            if (this.$route.path == "/customer") {
              this.$vux.alert.show({
                title: "提示",
                content: "网络连接失败， 请刷新重试",
                onHide() {
                  // var keepAliveVal = false;
                  location.reload();
                }
              });
            }
            that.mainLog(
              "WebsocketStatus为false，WebsocketStatus次数限制，不进行自动重连"
            );
            clearInterval(that.WebsocketInterVal);
            that.WebsocketInterVal = null;
            that.websock.close();
          }
        }
      }, 2000);
    },
    /**
     * @description: 客服心跳检测
     * @param {type} 
     * @return: 
     */
    checkAlive() {
      let that = this;
      clearInterval(that.AliveInterVal);
      that.AliveInterVal = null;
      that.aliveFalseCount = 0;
      this.AliveInterVal = setInterval(() => {
        if (!that.keepAlive) { // 心跳状态异常
          if (that.aliveFalseCount < 1) {
            that.mainLog("keepAlive为false，次数为" + that.aliveFalseCount);
            that.aliveFalseCount++;
          } else {
            that.mainLog(
              "keepAlive为false，keepAlive次数限制，关闭websocket，交给ws检测后进行重连"
            );
            clearInterval(that.AliveInterVal);
            that.AliveInterVal = null;
            that.websock.close();
            that.wsStatus = false;
          }
        } else { // 心跳状态正常
          that.keepAlive = false;
        }
        that.websocketsend('{"action":"keepAlive"}'); // 发起心跳
      }, 5000);
    },
    /**
     * @description: 连接建立时触发
     * @param {type} 
     * @return: 
     */
    websocketonopen() {
      //连接成功事件
      this.mainLog("WebSocket连接建立成功！");
      this.websock.id = new Date().getTime(); // 获取当前时间戳（日志标识）
      this.wsStatus = true;
      this.lockReconnect = true;
      if (sessionStorage.token) { // token存在， 去注册
        var sendMsg = {
          req: {
            clientType: "6",
            id: sessionStorage.token
          },
          action: "register"
        };
        sendMsg = JSON.stringify(sendMsg);
        this.websocketsend(sendMsg);
        this.mainLog('发起注册：' + JSON.stringify(sendMsg));
        this.registerCount++
      }
    },
    /**
     * @description: 客户端接收服务端数据时触发
     * @param {type} 
     * @return: 
     */
    websocketonmessage(evt) {
      //打印收到服务器的内容
      this.mainLog("WebsocketOnmessage:" + evt.data);
      var obj = JSON.parse(evt.data);
      // 连接返回
      if (obj.msgType == 0) { // 连接成功
        if (obj.status == 200) {
          this.$vux.toast.hide();
          this.keepAlive = true;
          this.checkSocket();
        }
        if (obj.status == 500) {
          this.$vux.toast.show({
            type: "text",
            width: "16em",
            time: 5000,
            text: " 服务器异常！"
          });
        }
      }
      // 注册返回
      if (obj.msgType == 5) { //ws鉴权成功(注册成功)
        if (obj.status == 200) {
          this.registerCount = 0;
          this.$vux.toast.hide();
          this.keepAlive = true;
          this.checkSocket();
          this.checkAlive();
        } else if (obj.status == 500) {
          this.$vux.toast.show({
            type: "text",
            width: "16em",
            time: 5000,
            text: " 服务器异常！"
          });
        } else {
          // websocket 返回
          if (sessionStorage.token) { // 用户token存在
            if (this.websock.readyState == 1) { // 判断连接是否正常
              if (this.registerCount < 10) {
                if (this.registerCount % 5 !== 0 || this.registerCount == 0) {
                  clearInterval(this.AliveInterVal);
                  this.AliveInterVal = null;
                  this.keepAlive = true;
                  this.aliveFalseCount = 0;
                  var sendMsg = {
                    req: {
                      clientType: "6",
                      id: sessionStorage.token
                    },
                    action: "register"
                  };
                  sendMsg = JSON.stringify(sendMsg);
                  this.mainLog("心跳失败，重新注册：" + JSON.stringify(sendMsg));
                  this.websocketsend(sendMsg);
                  this.registerCount++
                } else {
                  let currentRegisterCount = this.registerCount;
                  this.resetWebsocket();
                  this.registerCount = currentRegisterCount;
                  this.initWebSocket();
                }
              } else {
                this.$vux.alert.show({
                  title: "提示",
                  content: "服务器异常！",
                });
                this.resetWebsocket();
              }
            }
          } else {
            this.$vux.toast.show({
              type: "text",
              width: "16em",
              time: 5000,
              text: "登陆超时。 请重新登录"
            });
            this.toLoginFunc();
          }
        }
      }

      //心跳返回
      if (obj.msgType == 6) {
        if (obj.status == 200) { // 心跳正常
          this.keepAlive = true;
          this.aliveFalseCount = 0;
        } else if (obj.status == 300) { // 心跳失败，立即重新注册
          if (sessionStorage.token) { // 用户token存在
            if (this.websock.readyState == 1) { // 判断连接是否正常
              if (this.registerCount < 10) {
                if (this.registerCount % 5 !== 0 || this.registerCount == 0) {
                  clearInterval(this.AliveInterVal);
                  this.AliveInterVal = null;
                  this.keepAlive = true;
                  this.aliveFalseCount = 0;
                  var sendMsg = {
                    req: {
                      clientType: "6",
                      id: sessionStorage.token
                    },
                    action: "register"
                  };
                  sendMsg = JSON.stringify(sendMsg);
                  this.mainLog("心跳失败，重新注册：" + JSON.stringify(sendMsg));
                  this.websocketsend(sendMsg);
                  this.registerCount++
                } else {
                  let currentRegisterCount = this.registerCount;
                  this.resetWebsocket();
                  this.registerCount = currentRegisterCount;
                  this.initWebSocket();
                }
              } else {
                this.$vux.alert.show({
                  title: "提示",
                  content: "服务器异常！",
                });
                this.resetWebsocket();
              }
            }
          } else {
            this.$vux.toast.show({
              type: "text",
              width: "16em",
              time: 5000,
              text: "登陆超时。 请重新登录"
            });
            this.toLoginFunc();
          }
        } else {
          this.$vux.toast.show({
            type: "text",
            width: "16em",
            time: 5000,
            text: " 服务器异常！"
          });
        }
      }
      this.$store.state.wsdata = obj;
      if (this.$isPc() && this.$store.state.pcCsrShow) {
        this.$store.state.CustomerPage &&
          this.$store.state.CustomerPage.receiveMsg(obj);
      } else {
        if (this.$route.path == "/customer") {
          this.$store.state.CustomerPage &&
            this.$store.state.CustomerPage.receiveMsg(obj);
        }
      }

      //订单支付结果通知
      if (obj.msgType == 19 && this.$route.path == "/mallOrderDetail") {
        this.$store.state.OrderDetailPage.receiveMsg(obj);
      }

      //多地登录
      if (obj.msgType == 11) {
        this.$vux.toast.show({
          type: "text",
          width: "16em",
          time: 5000,
          text: " 该账号在其它地方登录！"
        });
        this.$store.state.token = null;
        this.$store.state.userInfo = {
          poster: '',
          displayName: ''
        };
        // 关闭websocket连接
        this.resetWebsocket();
        if (this.$isPc()) {
          this.$router.push('/mallGoods');
        }

        this.toLoginFunc();
      }

    },
    /**
     * @description: 通信发生错误时触发
     * @param {type} 
     * @return: 
     */
    websocketonerror(e) {
      this.lockReconnect = true;
      //连接失败事件
      this.mainLog("WebSocket连接发生错误！");
      console.log(e);
      this.wsStatus = false;
      if (this.websock) {
        this.websock.close();
      }
    },
    /**
     * @description: 连接关闭时触发
     * @param {type} 
     * @return: 
     */
    websocketclose(e) {
      this.lockReconnect = true;
      //连接关闭事件
      this.mainLog("WebSocket连接关闭！");
      console.log(e);
      this.wsStatus = false;
      if (this.websock) {
        this.websock.close();
      }
    },
    /**
     * @description: 封装使用连接发送数据函数
     * @param {type} 
     * @return: 
     */
    websocketsend(msg, type_) {
      if (this.websock) {
        if (this.websock.readyState == 1) {
          this.websock.send(msg);
        } else {
          this.mainLog('websock连接关闭！消息发送失败');
          if (type_ == 1) {
            this.$vux.toast.show({
              type: "text",
              width: "16em",
              time: 5000,
              text: "发送失败 ，网络异常！"
            });
          }
          this.mainLog('重连次数' + this.reconnectCount);
          if (this.reconnectCount == 0 || this.reconnectCount >= 10) {
            this.resetWebsocket(); //  重置
            this.initWebSocket(); //  重连
          }
        }
      } else {
        this.mainLog('websock实例未初始化!');
        if (type_ == 1) {
          this.$vux.toast.show({
            type: "text",
            width: "16em",
            time: 5000,
            text: "发送失败 ，网络异常！"
          });
        }
        this.resetWebsocket();
        this.initWebSocket();
      }
    },
    /**
     * @description: 判断websocket实例是否初始化
     * @param {type} 
     * @return: 
     */
    whetherInitWebSocket() {
      if (!this.websock) { // websock不存在
        this.mainLog("websock实例未初始化!");
        this.$vux.toast.show({
          type: "text",
          width: "16em",
          time: 5000,
          text: "网络异常，正在重连..."
        });
        this.resetWebsocket();
        this.initWebSocket();
      }
    },
    /**
     * @description: 重置websocket
     * @param {type} 
     * @return: 
     */
    resetWebsocket() {
      if (this.websock) {
        this.websock.close();
      }
      this.websock = null;
      this.reconnectCount = 0;
      this.aliveFalseCount = 0;
      this.registerCount = 0;
      clearInterval(this.AliveInterVal);
      this.AliveInterVal = null;
      clearInterval(this.WebsocketInterVal);
      this.WebsocketInterVal = null;
      this.keepAlive = true;
      this.lockReconnect = true;
      this.wsStatus = false;
    },
    /**
     * @description: websocket日志
     * @param {type} 
     * @return: 
     */
    mainLog(log) {
      if (this.wsStatus && this.websock) {
        this.$LonbonLog("主页面日志（" + this.websock.id + "）", log);
      } else {
        this.$LonbonLog("主页面日志", log);
      }
    }
  }
};

export default webSocketMixin = webSocketMixin;



// WEBPACK FOOTER //
// ./src/components/common/customWebSocket.js